document.addEventListener( 'change', ( event ) => {
	const target = event.target;

	if (
		! target.matches( '.req-filter-query-block__select' ) ||
		! target.form
	) {
		return;
	}

	target.form.submit();
} );
